import TaggedApi from '../../classes/TaggedApi';

class UserApi extends TaggedApi {
    /** USERS API  */

    /**
     * Register an user.
     * @param {Object} data {
     *    @param {String} name
     *    @param {String} email
     *    @param {String} password
     *    @param {String} password_confirmation
     *    @param {Boolean} terms_and_conditions
     *    @param {Date} birthday (Optional)
     *    @param {String} nro_doc (Optional)
     *    @param {String} gender (Masculino / Femenino) (Optional)
     *    @param {String} description (Optional)
     *    @param {String} mobile_phone (Optional)
     *  }
     * @return {}
     */
    register(data) {
        const customHeaders = {
            'Content-Type': 'multipart/form-data'
        };
        return this.post('/api/users', data, customHeaders);
    }

    /**
     * Update an user.
     * @param {Object} data {
     *    @param {String} name
     *    @param {String} email
     *    @param {String} password
     *    @param {String} password_confirmation
     *    @param {Date} birthday (Optional)
     *    @param {String} nro_doc (Optional)
     *    @param {String} gender (Masculino / Femenino) (Optional)
     *    @param {String} description (Optional)
     *    @param {String} mobile_phone (Optional)
     *  }
     * @return {}
     */
    update(data) {
        console.log('🌐 [UserApi] update() called with FormData');
        console.log('🌐 [UserApi] FormData keys:');
        for (let key of data.keys()) {
            console.log(`  - ${key}:`, data.get(key));
        }
        const customHeaders = {
            'Content-Type': 'multipart/form-data'
        };
        data.append('_method', 'PUT');
        console.log('🌐 [UserApi] Making POST request to /api/users');
        return this.post('/api/users', data, customHeaders)
            .then((response) => {
                console.log('✅ [UserApi] update() success:', response);
                return response;
            })
            .catch((error) => {
                console.log('❌ [UserApi] update() error:', error);
                throw error;
            });
    }

    /**
     * Update user photo.
     * @param {Object} data {
     *    @param {File} profile (Image)
     *  }
     * @return {}
     */
    updatePhoto(data) {
        return this.put('/api/users/photo', data);
    }

    /**
     * Show an user.
     * @param {Integer} id
     * @return User
     */
    show(id) {
        if (!id) {
            id = 'me';
        }
        return this.get('/api/users/' + id, {});
    }

    /**
     * Get visible badges for a user.
     * @param {string|number} id - User id or 'me'
     * @return {Promise}
     */
    getBadges(id) {
        if (!id) {
            id = 'me';
        }
        return this.get('/api/users/' + id + '/badges', {});
    }

    list(data) {
        return this.get('/api/users/list', data);
    }

    registerDonation(data) {
        return this.post('/api/users/donation', data);
    }

    getBankData(data) {
        return this.get('/api/users/bank-data', data);
    }

    getTermsText(lang) {
        return this.get('/api/users/terms' + (lang ? '?lang=' + lang : ''));
    }

    changeProperty(data) {
        return this.post(
            '/api/users/change/' + data.property + '/' + data.value,
            null
        );
    }

    selladoViaje() {
        return this.get('/api/users/sellado-viaje');
    }

    deleteAccountRequest() {
        return this.post('/api/users/delete-account-request', {});
    }

    deleteAccount() {
        return this.post('/api/users/delete-account', {});
    }

    getMercadoPagoOAuthUrl() {
        return this.get('/api/users/mercadopago-oauth-url', {});
    }

    getManualIdentityValidationCost() {
        return this.get('/api/users/manual-identity-validation-cost', {});
    }

    getManualIdentityValidationStatus() {
        return this.get('/api/users/manual-identity-validation', {});
    }

    createManualIdentityValidationPreference() {
        return this.post(
            '/api/users/manual-identity-validation/preference',
            {}
        );
    }

    createManualIdentityValidationQrOrder() {
        return this.post(
            '/api/users/manual-identity-validation/qr-order',
            {}
        );
    }

    submitManualIdentityValidation(requestId, formData) {
        if (formData && !formData.get('request_id')) {
            formData.append('request_id', requestId);
        }
        return this.post('/api/users/manual-identity-validation', formData, {
            'Content-Type': 'multipart/form-data'
        });
    }

    /**
     * Send phone verification code via SMS.
     * @return {Promise} Returns {success, message, expires_at}
     */
    sendPhoneVerificationCode() {
        return this.post('/api/users/send-phone-verification', {});
    }

    /**
     * Verify phone verification code.
     * @param {string} code - 6-digit verification code
     * @return {Promise} Returns {success, message, user}
     */
    verifyPhoneCode(code) {
        return this.post('/api/users/verify-phone-code', { code });
    }

    /**
     * Generate a bio for the user using AI
     * @return {Promise} Returns generated bio text
     */
    generateBio() {
        return this.post('/api/users/generate-bio', {});
    }
}

export { UserApi as default };
